import NoShrinkBadge from "../../../Boilerplate/_Shared/NoShrinkBadge";

// Single source of truth for the work ⇄ private contact-type colour scheme. Use this everywhere
// a relationship/type chip appears (emails, phones, addresses) so the same kind always reads the
// same colour across the app — don't hardcode `color=` on a raw <Badge> at the call site again.
//
//   business → slate blue-grey      personal → forest green (brand)      other → grey
//   phone type (mobile/mobilePrivate/office/home) → neutral grey; the label text carries the meaning.
//
// PRIMÄR is deliberately NOT in this map: it's a ranking accent (rendered as a star), not a type,
// so it stays visually decoupled from the type palette.
const CONTACT_KIND_COLOR = {
  business: "brandSlate",
  personal: "forest",
  other: "gray",
  mobile: "gray",
  mobilePrivate: "gray",
  office: "gray",
  home: "gray",
};

/**
 * Semantic, non-truncating contact chip. Dot variant by brand convention: the colour rides on a
 * small dot with ink text, so the type reads at a glance while staying calm and low-ink.
 * `kind` selects the colour; `children` is the already-translated label text.
 */
export default function ContactBadge({ kind, children, style, ...props }) {
  return (
    <NoShrinkBadge
      size="xs"
      variant="dot"
      tt="none"
      fw={500}
      color={CONTACT_KIND_COLOR[kind] ?? "gray"}
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      {children}
    </NoShrinkBadge>
  );
}
